import AdminDashboardPage from "../pages/AdminPage/AdminDashboardPage";
import AdminRecipePage from "../pages/AdminPage/AdminRecipePage";
import HomePage from "../pages/PublicPage/HomePage";
import LoginSuccessPage from "../pages/PublicPage/LoginSuccessGooglePage";
import AccountPage from "../pages/UserPage/AccountPage";
import DailyMenuPage from "../pages/UserPremiumPage/DailyMenuPage";
import ProfilePage from "../pages/UserPage/ProfilePage";
import FavoriteListsPage from "../pages/UserPremiumPage/FavoriteListsPage";
import EatingHistoryPage from "../pages/UserPremiumPage/EatingHistoryPage";
import AdminLayoutComponent from "../components/Layout/AdminLayoutComponent";
import DefaultLayoutComponent from "../components/Layout/DefaultLayoutComponent";
import RecipePage from "../pages/PublicPage/RecipePage";
import HealthProfilePage from "../pages/UserPremiumPage/HealthProfilePage";
import ChangePasswordPage from "../pages/UserPage/ChangePasswordPage";
import AdminLoginPage from "../pages/PublicPage/AdminLoginPage";
import AdminMenuPage from "../pages/AdminPage/AdminMenuPage";
import NotFoundPage from "../pages/PublicPage/NotFoundPage";
import AdminLoginRoute from "../components/AdminLoginRoute";
import MenuPage from "../pages/PublicPage/MenuPage";
import MenuDetailPage from "../pages/PublicPage/MenuDetailPage";
import MenuRecipePage from "../pages/PublicPage/MenuRecipePage";
import HomeBlogPage from "../pages/PublicPage/HomeBlogPage";
import AllBlogPage from "../pages/PublicPage/AllBlogPage";
import CategoryBlogPage from "../pages/PublicPage/CategoryBlogPage";
import ManageSubscriptionPage from "../pages/UserPage/ManageSubscriptionPage";
import PaymentPage from "../pages/PublicPage/PaymentPage";
import BlogDetailPage from "../pages/PublicPage/BlogDetailPage";
import PaymentFailed from "../pages/PublicPage/PaymentFailed";
import PaymentSuccess from "../pages/UserPage/PaymentSuccess";
import SettingsPage from "../pages/UserPage/SettingsPage";

// Các tuyến đường công khai (không cần đăng nhập)
export const publicRoutes = [
  {
    path: "/",
    page: HomePage,
    layout: DefaultLayoutComponent,
  },
  {
    path: "/login-success",
    page: LoginSuccessPage,
  },

  {
    path: "/recipes",
    page: RecipePage,
    layout: DefaultLayoutComponent,
  },
  {
    path: "/recipes/:slug",
    page: MenuRecipePage,
    layout: DefaultLayoutComponent,
  },
  {
    path: "/blogs",
    page: HomeBlogPage,
    layout: DefaultLayoutComponent,
  },
  {
    path: "/blogs/all-blogs",
    page: AllBlogPage,
    layout: DefaultLayoutComponent,
  },
  {
    path: "/blogs/category/:slug",
    page: CategoryBlogPage,
    layout: DefaultLayoutComponent,
  },
  {
    path: "/blogs/detail/:slug",
    page: BlogDetailPage,
    layout: DefaultLayoutComponent,
  },

  {
    path: "/admin/login",
    page: AdminLoginPage,
    wrapper: AdminLoginRoute,
  },
  {
    path: "/menus",
    page: MenuPage,
    layout: DefaultLayoutComponent,
  },
  {
    path: "/menus/:slug",
    page: MenuDetailPage,
    layout: DefaultLayoutComponent,
  },
];

// Các tuyến đường quản trị
export const adminRoutes = [
  {
    path: "/admin/dashboard",
    page: AdminDashboardPage,
    layout: AdminLayoutComponent,
    isPrivate: true,
    allowedRoles: ["ADMIN"],
  },
  {
    path: "/admin/recipes",
    page: AdminRecipePage,
    layout: AdminLayoutComponent,
    isPrivate: true,
    allowedRoles: ["ADMIN"],
  },
  {
    path: "/admin/menus",
    page: AdminMenuPage,
    layout: AdminLayoutComponent,
    isPrivate: true,
    allowedRoles: ["ADMIN"],
  },
];

// Các tuyến đường người dùng premium
export const userPremiumRoutes = [
  {
    path: "/account/daily-menu",
    page: DailyMenuPage,
    layout: DefaultLayoutComponent,
    isPrivate: true,
    isPremium: true,
  },
  {
    path: "/account/favorites",
    page: FavoriteListsPage,
    layout: DefaultLayoutComponent,
    isPrivate: true,
    isPremium: true,
  },
  {
    path: "/account/eating-history",
    page: EatingHistoryPage,
    layout: DefaultLayoutComponent,
    isPrivate: true,
    isPremium: true,
  },
  {
    path: "/account/health-profile",
    page: HealthProfilePage,
    layout: DefaultLayoutComponent,
    isPrivate: true,
    isPremium: true,
  },
];

// Các tuyến đường người dùng
export const userRoutes = [
  {
    path: "/account",
    page: AccountPage,
    layout: DefaultLayoutComponent,
    isPrivate: true,
  },
  {
    path: "/account/profile",
    page: ProfilePage,
    layout: DefaultLayoutComponent,
    isPrivate: true,
  },
  {
    path: "/account/change-password",
    page: ChangePasswordPage,
    layout: DefaultLayoutComponent,
    isPrivate: true,
  },

  {
    path: "/payment/failed",
    page: PaymentFailed,
    layout: DefaultLayoutComponent,
  },
  {
    path: "/payment/success",
    page: PaymentSuccess,
    layout: DefaultLayoutComponent,
  },
  {
    path: "/account/subscription",
    page: ManageSubscriptionPage,
    layout: DefaultLayoutComponent,
    isPrivate: true,
  },
  {
    path: "/payment",
    page: PaymentPage,
    layout: DefaultLayoutComponent,
    isPrivate: true,
  },
  {
    path: "/menus",
    page: MenuPage,
    layout: DefaultLayoutComponent,
    isPrivate: true,
  },
  {
    path: "/menus/:slug",
    page: MenuDetailPage,
    layout: DefaultLayoutComponent,
    isPrivate: true,
  },
  {
  path: "/account/settings",
  page: SettingsPage,
  layout: DefaultLayoutComponent,
  isPrivate: true,
}

];

// Tuyến đường không tìm thấy
export const notFoundRoute = {
  path: "*",
  page: NotFoundPage,
};

// Kết hợp tất cả các tuyến đường
export const routes = [
  ...publicRoutes,
  ...adminRoutes,
  ...userRoutes,
  ...userPremiumRoutes,
  notFoundRoute,
];
